import { Link } from '@tanstack/react-router'
import { YOUTUBE_URL, TWITTER_HANDLE } from '@/shared/lib/constants'
import { OAC } from '@/content/oac'

export function Footer() {
  return (
    <footer className="border-t border-[#232a26] bg-[#0e1110] px-4 py-16">
      <div className="mx-auto max-w-5xl">
        <div className="mb-12 grid gap-10 md:grid-cols-2">
          <div>
            <Link
              to="/"
              className="mb-4 inline-block text-xl font-semibold tracking-tight text-[#f0f3f1]"
            >
              control
              <span className="text-[#80cca5]">stack</span>
              <span className="text-[#8b958f]">.ai</span>
            </Link>
            <p className="max-w-sm leading-relaxed text-[#c3ccc7]">
              Practical AI coding workflows, from the DarrenBuildsAI channel.
              Operated by Daza Limited.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8">
            <div>
              <h2 className="mb-4 text-xs font-semibold uppercase tracking-widest text-[#8b958f]">
                Explore
              </h2>
              <ul className="space-y-3">
                <li>
                  <Link
                    to="/call"
                    className="text-[#c3ccc7] transition-colors hover:text-[#80cca5]"
                  >
                    Work with me
                  </Link>
                </li>
                <li>
                  <a
                    href={OAC.repoUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#c3ccc7] transition-colors hover:text-[#80cca5]"
                  >
                    {OAC.name}
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h2 className="mb-4 text-xs font-semibold uppercase tracking-widest text-[#8b958f]">
                Follow / Legal
              </h2>
              <ul className="space-y-3">
                <li>
                  <a
                    href={YOUTUBE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#c3ccc7] transition-colors hover:text-[#80cca5]"
                  >
                    YouTube
                  </a>
                </li>
                <li>
                  <a
                    href={`https://twitter.com/${TWITTER_HANDLE.replace('@', '')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#c3ccc7] transition-colors hover:text-[#80cca5]"
                  >
                    Twitter
                  </a>
                </li>
                <li>
                  <Link
                    to="/privacy"
                    className="text-[#c3ccc7] transition-colors hover:text-[#80cca5]"
                  >
                    Privacy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/terms"
                    className="text-[#c3ccc7] transition-colors hover:text-[#80cca5]"
                  >
                    Terms
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col justify-between gap-4 border-t border-[#232a26] pt-8 text-sm text-[#8b958f] md:flex-row">
          <p>© 2026 controlstack.ai</p>
          <Link
            to="/cookies"
            className="transition-colors hover:text-[#80cca5]"
          >
            Cookie Policy
          </Link>
        </div>
      </div>
    </footer>
  )
}
